import classNames from 'classnames';
import { ReactNode } from 'react';
import { Button } from 'ui';
import { ArrowLeftIcon } from 'ui/icons';
import { CompliOneWhiteLogo } from 'ui/icons/logo';

export const defaultSideBarFilling = (
  <>
    <div className="flex gap-3 w-[120px] items-center self-start select-none">
      <img src="/sr-logo-gray.svg" alt="sr logo" />
      <span className="text-white leading-5">Share registry</span>
    </div>
    <p className="text-[48px] leading-[55px] !m-0 font-serif font-semibold">
      Empowering the Australian Investment Community
    </p>
  </>
);

export interface SignUpPagesWrapperProps {
  mainAction?: {
    name: string;
    onClick: () => void;
    helpText?: string | ReactNode;
    className?: string;
  };
  backAction?: {
    name?: string;
    onClick: () => void;
    className?: string;
  };
  children: ReactNode;
  className?: string;
  sidebar?: ReactNode;
}
export const SignUpPagesWrapper = ({
  children,
  backAction,
  mainAction,
  className,
  sidebar,
}: SignUpPagesWrapperProps) => {
  return (
    <div className="w-full h-full flex justify-start items-start">
      <div>
        <div className="h-screen w-[445px] text-white hidden lg:block">
          <img
            src="/sidebar.png"
            width="436"
            alt="sidebar background"
            className="h-screen absolute top-0 left-0"
          />
          <div className="relative w-full h-full flex gap-3 flex-col items-center justify-center space-y-10 pl-9 pr-14">
            <div className="flex justify-between w-[340px] absolute top-7 left-10">
              <a href="https://complione.com.au">
                <h2 className="flex gap-3 select-none">
                  <img src={CompliOneWhiteLogo} alt="logo" className="h-[45px]" />
                </h2>
              </a>
              <a
                href="https://complione.com.au"
                className="border rounded hover:bg-black hover:bg-opacity-30 py-2 px-4 border-opacity-20"
              >
                Go to website
              </a>
            </div>
            {sidebar || defaultSideBarFilling}
          </div>
        </div>
      </div>

      <div
        className={classNames(
          'w-full flex flex-col',
          {
            'justify-center': !className?.includes('justify-'),
            'items-center': !className?.includes('items-'),
            'max-h-full h-full': !className?.includes('h-'),
            'py-6': !className?.includes('py-'),
            'gap-3': !className?.includes('gap-'),
            'overflow-y-auto': !className?.includes('overflow-'),
          },
          className,
        )}
      >
        {(mainAction || backAction) && (
          <div className="w-full flex justify-between sm:px-10 px-6 items-center">
            {backAction ? (
              <button onClick={backAction?.onClick} className="flex gap-3">
                <img alt="back" src={ArrowLeftIcon} className="w-6 h-6 min-w-6 min-h-6" />
                <span>{backAction.name || 'Back'}</span>
              </button>
            ) : (
              <div></div>
            )}
            {mainAction && (
              <div className="flex gap-8 align-middle justify-between w-fit max-w-full">
                {typeof mainAction.helpText === 'string' && (
                  <div className="flex justify-center items-center">
                    <p className="text-gray-900 text-sm text-justify text-opacity-64 ">
                      {mainAction.helpText}
                    </p>
                  </div>
                )}
                {mainAction && typeof mainAction.helpText !== 'string' && mainAction.helpText}
                <Button
                  onClick={mainAction.onClick}
                  variant="secondary"
                  className={classNames('w-fit px-2')}
                >
                  {mainAction.name}
                </Button>
              </div>
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
